enum CpuModel{
    GD32F303 = 0,
    AT32F403A = 1,
    GD32F502 = 2
}

enum UserRole {
    user,sale,support,repair,manuf,root
}

enum AdminRole {
    root,
    technician,maintenance,assembler
}

enum Life{
    submited,issued,ended
}

enum MessageWay{
    sms,email,notify,popup
}


var enums:{[key:string]:any} = {
    "user_role":UserRole,
    "admin_role":AdminRole,
    "life":Life,
    "message_way":MessageWay,
    "cpu_model":CpuModel
}

export default enums;
